var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#EBFBF3",
    stroke: "#38D687",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5588 22.5003C30.8351 22.1917 30.8089 21.7175 30.5003 21.4412C30.1917 21.1649 29.7175 21.1911 29.4412 21.4997L26.0721 25.2629C25.3894 26.0254 24.9296 26.5363 24.5365 26.8667C24.1621 27.1814 23.9421 27.25 23.75 27.25C23.5579 27.25 23.3379 27.1814 22.9635 26.8667C22.5704 26.5363 22.1106 26.0254 21.4279 25.2629L20.5588 24.2921C20.2825 23.9835 19.8083 23.9573 19.4997 24.2336C19.1911 24.5099 19.1649 24.984 19.4412 25.2926L20.3475 26.3049C20.9834 27.0152 21.5137 27.6076 21.9984 28.0149C22.511 28.4458 23.0639 28.75 23.75 28.75C24.4361 28.75 24.989 28.4458 25.5016 28.0149C25.9862 27.6076 26.5166 27.0152 27.1524 26.305L30.5588 22.5003Z",
    fill: "#38D687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 14.25C19.0629 14.25 14.25 19.0629 14.25 25C14.25 30.9371 19.0629 35.75 25 35.75C30.9371 35.75 35.75 30.9371 35.75 25C35.75 19.0629 30.9371 14.25 25 14.25ZM15.75 25C15.75 19.8914 19.8914 15.75 25 15.75C30.1086 15.75 34.25 19.8914 34.25 25C34.25 30.1086 30.1086 34.25 25 34.25C19.8914 34.25 15.75 30.1086 15.75 25Z",
    fill: "#38D687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTick);
export default __webpack_public_path__ + "static/media/SuccessfulTick.fe43faf4c349676aaa8169a3e16bef2c.svg";
export { ForwardRef as ReactComponent };